
import { Component, Prop, Vue } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import CellStore from '../../../stores/CellStore';
import { vSelectInModalWithPopper } from '../../../util';

@Component({
  components: {
    vSelect,
  },
})
export default class CellDropdown extends Vue {
  @Prop({ required: true })
  value!: number | number[];
  
  //set to true when dropdown is used in modals
  @Prop({ default: false })
  usePopper!: boolean;
  
  @Prop({ default: false })
  multiple!: boolean;
  @Prop({ default: false })
  clearable!: boolean;
  @Prop({ default: null })
  cells!: { id: number, name: string }[] | null;

  private readonly cellStore = new CellStore();

  get binds(): Record<string, unknown> {
    const ret = {};
    if (this.usePopper) {
      Object.assign(ret, {
        appendToBody: true,
        calculatePosition: vSelectInModalWithPopper,
      });
    }
    return ret;
  }

  get options(): { id: number, name: string }[] {
    return this.cells ?? this.cellStore.cellsForVSelect;
  }

  mounted(): void {
    this.cellStore.loadIfAbsent();
  }
}
